import React, { useMemo } from 'react';
import DesktopFormResponsesContainer from '../../formResponses/DesktopFormResponsesContainer';
import { getPortfolioFormName, buildPropertiesMap } from '../../../utils/formDisplayNames';

/**
 * Desktop Responses Tab Component
 * 
 * Refactored to use the new reusable FormResponsesContainer
 * This tab is part of the Capture Tools interface and displays all form responses
 * for a given property or portfolio context.
 */
const DesktopResponsesTab = ({ propertyTab, portfolio }) => {
  // Column configuration - can be customized per view
  const responseColumns = [
    { key: 'name', label: 'Contact Name', width: '200px', sortable: true },
    { key: 'email', label: 'Email', width: '220px', sortable: true },
    { key: 'source', label: 'Source Page', width: '150px', sortable: true },
    { key: 'submittedAtFormatted', label: 'Received', width: '150px', sortable: true },
  ];

  // Shared name derivation — same as QR Generator & Automations
  const propertiesMap = useMemo(
    () => buildPropertiesMap(propertyTab?.properties),
    [propertyTab?.properties],
  );

  const portfolioName = getPortfolioFormName(portfolio?.data);

  return (
    <div className="max-w-6xl mx-auto">
      <DesktopFormResponsesContainer
        columns={responseColumns}
        title="Form Responses"
        subtitle="All submissions from website and property pages."
        propertiesMap={propertiesMap}
        portfolioName={portfolioName}
        onResponseSelected={(response) => {
          // Optional callback for when a response is selected
          console.log('[DesktopResponsesTab] Response selected:', response);
        }}
      />
    </div>
  );
};

export default DesktopResponsesTab;
